<template>
  <el-dialog
    title="编辑客户从属关系"
    :visible.sync="visible"
    width="700px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form size="small" :model="model" ref="customerForm" label-width="100px">
      <el-form-item size="small" label="属客户" prop="name">
        <el-input
          size="small"
          v-model="model.name"
          disabled
          placeholder="请输入客户名称"
        ></el-input>
      </el-form-item>

      <el-form-item label="主客户">
        <customer-select
          style="width: 100%"
          :val="model.parent_id"
          :filterCustomerID="model.id"
          @change="model.parent_id = $event"
        ></customer-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitCustomerForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { updateCustomerParent } from '@/service/getData'
import CustomerSelect from '@/components/select/customer_select'

export default {
  components: {
    CustomerSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.customerForm.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
    }
  },
  methods: {
    submitCustomerForm() {
      this.$refs.customerForm.validate(async (valid) => {
        if (valid) {
          let res = await updateCustomerParent(this.model)
          if (res.code == 0) {
            this.$emit('updatedCustomer', res.data)
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>